module.exports = __webpack_public_path__ + "img/bonus7.4527e67c.png";